import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import BackButton from 'components/BackButton';
import TimeZoneSelect from 'components/time-zone-select';
import toast from 'react-hot-toast';
import { getUserData } from 'utils';
import { createAPIEndPoint } from 'config/api/api';
import { useUserProfile } from 'contexts/UserProfileContext';
import Loader from 'loaders/Loader';

function ClinicProfile() {
  const { getUser } = useUserProfile();
  const [loading, setLoading] = useState(true);
  const userData = getUserData();
  const userId = userData?.id ?? null;
  const clinic_id = userData?.clinic_id ?? null;

  const textColor = useColorModeValue('navy.700', 'white');
  const [user, setUser] = useState({});

  const fetchUser = async () => {
    try {
      const response = await createAPIEndPoint('clinic').fetchById(
        `/${clinic_id}`,
      );
      setUser({
        ...response.data.clinic,
        user_email: response.data.user?.email,
        user_name: `${response.data.user?.first_name} ${response.data.user?.last_name}`,
      });
      console.log(' fetchUser ~ response:', response);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching user:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [userId]);

  const updateProfile = async (profileData) => {
    try {
      await createAPIEndPoint('clinic/').update(clinic_id, profileData);
      getUser();
      fetchUser();
      toast.success('Clinic profile updated successfully!');
    } catch (error) {
      throw (
        error?.response?.data?.message ||
        'Profile update failed. Please try again.'
      );
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      clinic_name: user.clinic_name || '',
      address: user.address || '',
      timezone: user.timezone || '',
    },
    validationSchema: Yup.object().shape({
      clinic_name: Yup.string().max(255).required('Clinic name is required'),
      address: Yup.string().max(255).required('Address is required'),
      // timezone: Yup.string().required('Time Zone is required'),
    }),
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        await updateProfile(values);
        resetForm();
      } catch (error) {
        setErrors({ submit: error });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      {' '}
      {loading && <Loader />}
      <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
        <BackButton />
        <Flex align="center" justify="center">
          <Box p={6} borderRadius="lg" boxShadow="lg" bg="white" w="500px">
            <Heading
              color={textColor}
              fontSize={{ base: '22px', md: '26px', lg: '28px' }}
              mb="10px"
            >
              Clinic Profile
            </Heading>
            <form onSubmit={formik.handleSubmit}>
              <FormControl
                isInvalid={
                  formik.touched.clinic_name && formik.errors.clinic_name
                }
                mb={4}
              >
                <FormLabel>Clinic Name</FormLabel>
                <Input
                  name="clinic_name"
                  placeholder="Enter clinic name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.clinic_name}
                />
                {formik.touched.clinic_name && formik.errors.clinic_name && (
                  <Text color="red.500" fontSize="sm">
                    {formik.errors.clinic_name}
                  </Text>
                )}
              </FormControl>

              <FormControl
                isInvalid={formik.touched.address && formik.errors.address}
                mb={4}
              >
                <FormLabel>Address</FormLabel>
                <Input
                  name="address"
                  placeholder="Enter clinic address"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.address}
                />
                {formik.touched.address && formik.errors.address && (
                  <Text color="red.500" fontSize="sm">
                    {formik.errors.address}
                  </Text>
                )}
              </FormControl>

              {/* <TimeZoneSelect
                            values={formik.values}
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            touched={formik.touched}
                            errors={formik.errors}
                        /> */}

              <Button
                type="submit"
                colorScheme="blue"
                width="full"
                isLoading={formik.isSubmitting}
              >
                Save
              </Button>
            </form>
          </Box>
        </Flex>
      </Box>
    </>
  );
}

export default ClinicProfile;
